import { render, staticRenderFns } from "./PatientDepersonalizateModal.vue?vue&type=template&id=a229cbc4&scoped=true"
import script from "./PatientDepersonalizateModal.vue?vue&type=script&lang=js"
export * from "./PatientDepersonalizateModal.vue?vue&type=script&lang=js"
import style0 from "./PatientDepersonalizateModal.vue?vue&type=style&index=0&id=a229cbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a229cbc4",
  null
  
)

export default component.exports